import moment from "moment";

export const formatAddPurchasePayload = ({ purchaseDetails, paymentDetails = {}, purchaseItems, isPaid }) => {
  return {
    ...purchaseDetails,
    receivedDate: moment(`${purchaseDetails.receivedDate} ${moment().format("HH:mm:ss")}`).toISOString(),
    vendorId: Number(purchaseDetails.vendorId),
    paidAmount: paymentDetails.paidAmount ? Number(paymentDetails.paidAmount) : undefined,
    items: purchaseItems.map((item) => ({
      purchaseItemId: item.purchaseItemId,
      quantity: Number(item.quantity),
      unitOfMeasure: item.unitOfMeasure,
      price: Number(item.price),
      taxPercentage: Number(item.taxPercentage),
    })),
    fromAccountId: paymentDetails.fromAccountId ? Number(paymentDetails.fromAccountId) : undefined,
    isPaid,
  };
};

export const formatUpdatePurchasePayload = ({ purchaseDetails, purchaseItems }) => {
  return {
    purchaseOrderId: purchaseDetails.purchaseOrderId,
    description: purchaseDetails.description,
    receivedById: purchaseDetails.receivedById,
    receivedDate: moment(`${purchaseDetails.receivedDate} ${moment().format("HH:mm:ss")}`).toISOString(),
    projectId: purchaseDetails.projectId,
    projectStageId: purchaseDetails.projectStageId,
    discountAmount: Number(purchaseDetails.discountAmount),
    items: purchaseItems.map((item) => ({
      purchaseItemId: item.purchaseItemId,
      quantity: Number(item.quantity),
      unitOfMeasure: item.unitOfMeasure,
      price: Number(item.price),
      taxPercentage: Number(item.taxPercentage),
    })),
  };
};
